var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import styled, { css } from 'styled-components';
import { Magnifier } from '../../icons';
import { color, borderRadius, palette, spacing, typography } from '../../constants';
var activeStyles = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  outline: none;\n  border-color: ", ";\n  box-shadow: inset 0 0 0 1px ", ";\n"], ["\n  outline: none;\n  border-color: ", ";\n  box-shadow: inset 0 0 0 1px ", ";\n"])), palette.blue5, palette.blue5);
var FilterContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  position: relative;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  transition: border-color 100ms linear, box-shadow 100ms linear;\n  box-shadow: inset 0 0 0 1px transparent;\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  position: relative;\n  border: 1px solid ", ";\n  border-radius: ", ";\n  transition: border-color 100ms linear, box-shadow 100ms linear;\n  box-shadow: inset 0 0 0 1px transparent;\n  ",
    "\n"])), palette.neutral5, borderRadius.default, function (props) {
    return props.isFocused !== undefined && props.isFocused ? activeStyles : null;
});
var Input = styled.input(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex-grow: 1;\n  border: 0;\n  padding: 0 ", ";\n  height: 32px;\n  background-color: ", ";\n  ", ";\n  &::-webkit-search-cancel-button,\n  &::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n"], ["\n  flex-grow: 1;\n  border: 0;\n  padding: 0 ", ";\n  height: 32px;\n  background-color: ", ";\n  ", ";\n  &::-webkit-search-cancel-button,\n  &::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n"])), spacing.snug, color.pureWhite, typography.input);
var SearchIcon = styled(Magnifier)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  position: absolute;\n  right: ", ";\n  pointer-events: none;\n"], ["\n  position: absolute;\n  right: ", ";\n  pointer-events: none;\n"])), spacing.tight);
var InputWrap = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  background: ", ";\n  padding: ", ";\n"], ["\n  background: ",
    ";\n  padding: ",
    ";\n"])), function (props) {
    return props.isTransparent !== undefined && props.isTransparent
        ? 'transparent'
        : palette.neutral2;
}, function (props) {
    return props.isTransparent !== undefined && props.isTransparent
        ? spacing.extraTight
        : spacing.snug;
});
function useFocusState() {
    var _a = React.useState(false), isFocused = _a[0], setIsFocused = _a[1];
    return {
        isFocused: isFocused,
        focus: function () { return setIsFocused(true); },
        blur: function () { return setIsFocused(false); }
    };
}
export var FilterInput = function (_a) {
    var _b = _a.isTransparent, isTransparent = _b === void 0 ? false : _b, props = __rest(_a, ["isTransparent"]);
    var _c = useFocusState(), isFocused = _c.isFocused, focus = _c.focus, blur = _c.blur;
    return (React.createElement(InputWrap, { isTransparent: isTransparent },
        React.createElement(FilterContainer, { isFocused: isFocused },
            React.createElement(Input, __assign({ type: "search", onFocus: focus, onBlur: blur }, props)),
            React.createElement(SearchIcon, { small: true }))));
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=FilterInput.js.map